import {Injectable} from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class SessionService {
  put(key: string, value: any) {
    console.log(`SessionService.put: ${key}`, value);
    if (typeof value === 'object') {
      sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      sessionStorage.setItem(key, value);
    }
  }

  get(key: string): any {
    const value = sessionStorage.getItem(key);
    // console.log(`SessionService.get: ${key}`, value);
    return value;
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  destroy() {
    sessionStorage.clear();
  }
}